<ng-container *transloco="let t">
<ng-template #digitalAsset>
  @if (inEditMode) {
    <div class="d-flex mb-5">
      <label class="form-label mb-2">{{ t('wizard.digitalAssets.vendorForVerification') }}</label>
      <select #vendorToUseField="ngModel" class="form-select form-select-solid"
        [(ngModel)]="step.vendorToUse"
        name="vendorToUse">
        <option [ngValue]="null">{{ t('common.selectOne') }}</option>
        <option [ngValue]="'FormFree'">FormFree</option>
        <option [ngValue]="'Truv'">Truv</option>
        <option [ngValue]="'Argyle'">Argyle</option>
      </select>
    </div>
  }

  @if (voaEnabled && !isEditEnabled && thirdPartyEnrollmentWidget) {
    <digital-assets-verification
      (complete)="onNextClicked()"
      (error)="onNextClicked()"
      (close)="onNextClicked()"
      [applicationId]="mortgageApplication.applicationId"
      [borrowerId]="borrower.contactId"
      [taskId]="loanDocTaskId"
      [borrowerVerificationOrderId]="borrowerVerificationOrderId"
      [provider]="step.vendorToUse"
      [thirdPartyEnrollmentWidget]="thirdPartyEnrollmentWidget"
      [usesOrdersApi]="usesOrdersApi"
      >
    </digital-assets-verification>
  }

  @if (!voaEnabled && !isEditEnabled) {
    <div class="card-px text-center py-20 my-10">
      <h2 class="fs fw-bold mb-8">{{ t('wizard.digitalAssets.notAvailableTitle') }}</h2>
      <p class="text-gray-400 fs-4 fw-semibold mb-10">{{ t('wizard.digitalAssets.notAvailableMessage') }}
      </p>
      <a (click)="onSpecifyAssetsClicked()" class="btn btn-primary">{{ t('wizard.digitalAssets.tellUsAboutAssets') }}</a>
    </div>
  }
  @if (isEditEnabled) {
    <div class="card-px text-center py-20 my-10">
      <h2 class="fs fw-bold mb-8">{{ t('wizard.digitalAssets.editModePlaceholderTitle') }}</h2>
      <p class="text-gray-400 fs-4 fw-semibold mb-10">{{ t('wizard.digitalAssets.editModePlaceholderMessage') }}</p>
    </div>
  }
</ng-template>

<wizard-step-template [stepMainTemplate]="digitalAsset" [stepComponent]="this" [step]="step"></wizard-step-template>
</ng-container>
